import { atom } from "recoil";      
import { NFTInfoType } from "../model/nftInfoJsonType";
import { recoilPersist } from 'recoil-persist';

// const { persistAtom } = recoilPersist({
//     key:'nftJsonState',
//     storage:sessionStorage,
// });


// nftjsonから取得した連想配列の状態を保持する Atoms を作成。
export const nftJsonState = atom<NFTInfoType>({
    key: "nftJsonState",
    default:{
        name:'',
        external_url:'',
        description:'',
        image:'',
        profileicon:'',
        nftmeta:'',
        contractaddress:'',
        attributes:[],
        chainId:'',
        nftabi:'',
        chainRPCEndpoint:'',
    },
    // effects_UNSTABLE:[persistAtom],
});